import React, { useState, useEffect } from "react";
import { parsal_img } from "../../../assets/mediaCall";
import Modal from "../../../components/Modal";

const QuickBook = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedService, setSelectedService] = useState("");
  const handleOpenModal = (serviceName) => {
    setSelectedService(serviceName);
    setModalOpen(true);
  };
  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedService("");
  };
  useEffect(() => {
    if (modalOpen) {
      document.body.style.overflow = "hidden"; // Disable scrolling
    } else {
      document.body.style.overflow = ""; // Re-enable scrolling
    }

    // Cleanup when component unmounts or when modalOpen changes
    return () => {
      document.body.style.overflow = ""; // Ensure scrolling is re-enabled
    };
  }, [modalOpen]);

  const services = [
    { name: "Bike Taxi", image: parsal_img.bikeride, bg_color: "#E6F2EB" },
    { name: "Trucks", image: parsal_img.tempo, bg_color: "#E6F2EB" },
    { name: "2 Wheeler", image: parsal_img.scooter, bg_color: "#F4F4F4" },
    { name: "Packers & Movers", image: parsal_img.truck, bg_color: "#FFF6E8" },
    { name: "All India Parsal", image: parsal_img.india, bg_color: "#EBF4FF" }, // Two images for the fourth item
  ];

  // return (
  //   <>
  //     <div
  //       style={{ boxShadow: "0px 24px 54px 0px #7188F21A" }}
  //       className="py-7 px-10 mlg:px-10 smp:px-8 mlg:py-6 mlg:w-full mlg:static mlg:flex mlg:flex-col text-[var(--clr-black-1)] bg-[#FFFFFF] rounded-2xl mlg:rounded-none absolute bottom-[-113px] left-[50%] transform -translate-x-1/2 mlg:transform-none inter"
  //     >
  //       <h2 className="text-[18px] leading-[22px] font-semibold mb-3.5 sm:ml-[2%] smp:ml-0">
  //         book your PARSAL now!
  //       </h2>
  //       <div className="flex sm:justify-center sm:flex-wrap gap-10 mlg:gap-10 mdg:gap-4 mlg:justify-evenly">
  //         {services.map((service, index) => (
  //           <div
  //             key={index}
  //             onClick={() => handleOpenModal(service.name)}
  //             className="flex flex-col cursor-pointer transform transition duration-300 hover:scale-110 hover:shadow-lg items-center bg-white border rounded-2xl  w-40 smm:w-32 sm:w-36 smp:w-[160px] xs:w-[142px] max-w-1/4"
  //           >
  //             {/* Image Section with Conditional Rendering for Two Images */}
  //             <div
  //               style={{ backgroundColor: service.bg_color }}
  //               className={`rounded-t-2xl w-full flex justify-center relative`}
  //             >
  //               <img
  //                 src={service.image}
  //                 alt={service.name}
  //                 className="w-full h-24 smm:h-16 sm:h-20 smp:h-24 xs:h-16 px-2 object-contain"
  //               />
  //             </div>
  //             {/* Name Section */}
  //             <div className="p-2">
  //               <p className="text-center text-sm font-semibold">
  //                 {service.name}
  //               </p>
  //             </div>
  //           </div>
  //         ))}
  //       </div>
  //       {/* <div className="w-[90%] mx-auto bg-blue-600 max-w-[392px] text-[]">
  //       <div className="">Get an estimate</div>
  //     </div> */}
  //       {/* <div
  //         className="w-[30%] min-w-[234px] cursor-pointer mx-auto bg-[#4F23CF] text-[16px] font-[500] text-white mt-6 rounded-2xl tracking-wide"
  //         onClick={handleOpenModal}
  //       >
  //         <div className="text-center py-4">book your PARSAL now!</div>
  //       </div> */}
  //     </div>
  //     <div className="relative ">
  //       {modalOpen && (
  //         <Modal
  //           closeModal={handleCloseModal}
  //           selectedService={selectedService}
  //         />
  //       )}
  //     </div>
  //   </>
  // );

  return (
    <>
      <div
        style={{ boxShadow: "0px 24px 54px 0px #7188F21A" }}
        className="py-7 px-10 lg:px-8 smp:px-6 lg:py-6 lg:w-full lg:static lg:flex lg:flex-col text-[var(--clr-black-1)] bg-[#FFFFFF] rounded-2xl lg:rounded-none absolute bottom-[-113px] left-[50%] transform -translate-x-1/2 lg:transform-none inter"
      >
        <h2 className="text-[18px] leading-[22px] font-semibold mb-3.5 sm:ml-[2%] smp:ml-0">
          book your PARSAL now!
        </h2>
        <div className="flex sm:justify-center sm:flex-wrap gap-8 lg:gap-8 mlg:gap-4 lg:justify-evenly">
          {services.map((service, index) => (
            <div
              key={index}
              onClick={() => handleOpenModal(service.name)}
              className="flex flex-col cursor-pointer transform transition duration-300 hover:scale-110 hover:shadow-lg items-center bg-white border rounded-2xl  w-40 mdg:w-32 sm:w-36 smp:w-[132px] xs:w-[142px] max-w-1/4"
            >
              {/* Image Section with Conditional Rendering for Two Images */}
              <div
                style={{ backgroundColor: service.bg_color }}
                className={`rounded-t-2xl w-full flex justify-center relative`}
              >
                <img
                  src={service.image}
                  alt={service.name}
                  className={`px-2 object-contain h-24 mdg:h-16 sm:h-20 smp:h-16 xs:h-16 ${
                    service?.name === "Bike Taxi"
                      ? "w-[75%] scale-90"
                      : "w-full"
                  }`}
                />
              </div>
              {/* Name Section */}
              <div className="p-2">
                <p className="text-center text-sm font-semibold">
                  {service.name}
                </p>
              </div>
            </div>
          ))}
        </div>
        {/* <div className="w-[90%] mx-auto bg-blue-600 max-w-[392px] text-[]">
        <div className="">Get an estimate</div>
      </div> */}
        {/* <div
          className="w-[30%] min-w-[234px] cursor-pointer mx-auto bg-[#4F23CF] text-[16px] font-[500] text-white mt-6 rounded-2xl tracking-wide"
          onClick={handleOpenModal}
        >
          <div className="text-center py-4">book your PARSAL now!</div>
        </div> */}
      </div>
      <div className="relative ">
        {modalOpen && (
          <Modal
            closeModal={handleCloseModal}
            selectedService={selectedService}
          />
        )}
      </div>
    </>
  );
};

export default QuickBook;
